<template>
  <div>
    <ValidationObserver ref="observer">
      <h1 class="common__main-title">Preparation limit Modification</h1>
      <div>
          <div v-for="(deadlineIds, key) in $route.params.deadlineIdGroups" :key="key">
            <Modification :deadlineIds="deadlineIds" :listNumber="key" ref="modifications" />
          </div>
      </div>
      <div class="common__button-container">
        <b-button
          pill
          variant="secondary"
          :to="{name:'PreparationLimitSetting'}"
        >
          Back
        </b-button>
        <b-button
          pill
          variant="primary"
          @click="confirm"
        >
          Confirm
        </b-button>
      </div>
    </ValidationObserver>
    <ConfirmModal ref="confirmModal" isLoadingMode @ok="updateDeadline" />
    <SuccessModal ref="sucessModal" @ok="successUpdate" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Modification from '@/components/parts/students/Modification.vue'
import ConfirmModal from '@/components/parts/modal/Confirm.vue';
import SuccessModal from '@/components/parts/modal/Success.vue';
import _ from 'lodash';
import moment from 'moment';
import { ValidationObserver } from 'vee-validate';

export default Vue.extend({
  components: {
    Modification,
    ConfirmModal,
    SuccessModal,
    ValidationObserver,
  },

  methods: {
    /* 更新確認モーダル表示 */
    confirm() {
      for (let i = 0; i < (this as any).$refs.modifications.length; i += 1) {
        // ここの条件式を変更するか悩み中(lessondataの方が良い?)
        if (moment((this as any).$refs.modifications[i].deadlines[0].expired).year() <= 2023) {
          this.$bvModal.msgBoxOk('Error - This data from 2021 to 2023 cannot be registered.');
          return
        }
      }
      (this.$refs.observer as any).validate().then((result: any) => {
        if (result) {
          (this.$refs.confirmModal as ConfirmModal).open('update?');
        }
      });
    },

    /* 更新 */
    async updateDeadline() {
      try {
        await Promise.all(
          (this.$refs.modifications as Vue[]).map((component: any) => {
            return component.register()
          }),
        );
        (this.$refs.sucessModal as SuccessModal).open();
      } catch (error: any) {
        const message = error.response?.data?.message || error;
        this.$bvModal.msgBoxOk(`Error - ${message}`);
      }
    },

    /* successモーダルOK押下時 */
    successUpdate() {
      this.$router.push({ name: 'PreparationLimitSetting' });
    },
  },

  created() {
    if (_.isEmpty(this.$route.params.deadlineIdGroups)) {
      this.$router.push({ name: 'PreparationLimitSetting' });
    }
  },
});
</script>
